import { jsx as _jsx } from "react/jsx-runtime";
export const ZurichIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 0.5L4.5 1.5L3.5 5V7H2.5V20H7V13H13V20H17.5V7H16.5V5L15.5 1.5L15 0.5L14.5 1.5L13.5 5V7H6.5V5L5.5 1.5L5 0.5ZM4 9.5H5V11.5H4V9.5ZM15 9.5H16V11.5H15V9.5ZM9 16H11V20H9V16Z",
            fill: "#D04A53"
        })
    });
